export default "__VITE_ASSET__D$LNGiRU__"